"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _cxs = _interopRequireDefault(require("cxs")),
    _vars = require("../../../common/styles/vars"),
    _default = (0, _cxs["default"])({
  background: "none",
  border: 0,
  color: _vars.COLOURS.grey.nevada,
  cursor: "pointer",
  fontWeight: _vars.FONT_WEIGHTS.medium,
  padding: 0,
  margin: 0,
  ":hover": {
    color: _vars.COLOURS.mono.black
  }
});

exports["default"] = _default;